import { render, staticRenderFns } from "./AscPreviousNextButtons.vue?vue&type=template&id=2480c734&"
import script from "./AscPreviousNextButtons.vue?vue&type=script&lang=js&"
export * from "./AscPreviousNextButtons.vue?vue&type=script&lang=js&"
import style0 from "./AscPreviousNextButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports